import { render, staticRenderFns } from "./SigningDocumentEditor.vue?vue&type=template&id=5a1c5e62"
import script from "./SigningDocumentEditor.vue?vue&type=script&lang=ts"
export * from "./SigningDocumentEditor.vue?vue&type=script&lang=ts"
import style0 from "./SigningDocumentEditor.vue?vue&type=style&index=0&id=5a1c5e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports